export default __webpack_public_path__ + "static/media/Comp 2_00022.15c2df88.png";